<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <Modal v-if="showModalListDocuments" :widthContainer="'90% !important'" :heightContainer="'50% !important'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#174a84;">{{modalTitle}}</h3>
      <div slot="body">
        <div class="">
          <div class="grid grid-cols-2 gap-4" style="border: 1px solid #12B3BD;padding:10px;margin-top:10px;"
           v-for="(document, index) in documents_list_filtered" :key="index">
            <div style="">
              <p style="width:70%;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Documento:</p>
              <p style="width:70%;word-wrap: break-word;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:300;">
                {{ `${document.name}.${document.extension}` }}
              </p>
            </div>
            <div>
              <input type="button" value="Eliminar" class="deleteDocumentButton" :id="`delete_document_${document.abbreviation}_${index}`" style="float:right;"
                v-on:click="deleteDocument(document.abbreviation, document.name)">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListDocuments = false">
      </div>
    </Modal>
    <div class="content-text" style="margin-top:30px;" v-if="showFormAccess">
      <div class="text">
        <div class="description">
          <p>Motivo de la Solicitud</p>
        </div>
        <div class="md:grid md:grid-cols-2 grid grid-cols-2 gap-4" style="margin-top:20px;">
          <div>
            <input type="button" class="chooseOptionButton w-full h-16" id="button_filter_accepted_request" value="Renuncia Voluntaria" style=""
              v-bind:style="{
                backgroundColor: reasonForTheRequest == 'normal' ? activeColorBackground : inactiveColorBackground, 
                color: reasonForTheRequest == 'normal' ? activeColorText : inactiveColorText,
                borderColor: reasonForTheRequest == 'normal' ? activeBorderColor : inactiveBorderColor
              }"
              v-on:click="changeButtonSelected('normal', true)"/>
          </div>
          <div>
            <input type="button" class="chooseOptionButton w-full h-16" id="button_filter_accepted_request" value="Defunción del Socio" style=""
              v-bind:style="{
                backgroundColor: reasonForTheRequest == 'defunción' ? activeColorBackground : inactiveColorBackground, 
                color: reasonForTheRequest == 'defunción' ? activeColorText : inactiveColorText,
                borderColor: reasonForTheRequest == 'defunción' ? activeBorderColor : inactiveBorderColor
              }"
              v-on:click="changeButtonSelected('defunción', false)"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.reasonForTheRequest == 'defunción'" style="margin-top:30px;">
      <Access ref="accessComponent" :tokenAuth="token_auth" :askNip="askNip" :showForm="showFormAccess"
        description="Ingresar los 13 caracteres del R.F.C. para solicitar tu renuncia." v-on:search-info-by-rfc-nip="getResponseAccess($event)"/>
    </div>
    <div v-if="this.reasonForTheRequest == 'normal'" style="margin-top:30px;">
      <Access ref="accessComponent" :tokenAuth="token_auth" :askNip="askNip" :showForm="showFormAccess"
        description="Ingresar los 13 caracteres del R.F.C. y tu NIP para solicitar tu renuncia." v-on:search-info-by-rfc-nip="getResponseAccess($event)"/>
    </div>
    <form @submit="renounce" v-if="rfcIsValid && !hasPendingRequest">
      <div style="margin-top:30px;">
        <div>
          <PersonalInfo title="Datos personales del Socio" :name="`${paternalName} ${maternalName} ${name}`" :rfc="rfcToShow" />
        </div>
        <div style="margin-top:30px;">
          <div style="margin-top:20px;">
            <p class="personalInfoTitle">Ingresa los datos que se te solicitan:</p>
          </div>
          <div class="mb-4">
            <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defunción'" id="input_beneficiarie_name" type="text"
              v-model.trim="$v.beneficiarie_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_name.$error, 'inputsForm':!$v.beneficiarie_name.$invalid}"
               placeholder="Primer Nombre del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_name')">
            <div class="content-text">
              <div v-if="$v.beneficiarie_name.$error" class="text">
                <span class="errors" v-if="!$v.beneficiarie_name.required">El primer nombre es requerido</span>
                <span class="errors" v-if="!$v.beneficiarie_name.minLength">Debe ingresar más de 2 caracteres en el primer nombre</span>
                <span class="errors" v-if="!$v.beneficiarie_name.maxLength">Debe ingresar máximo 30 caracteres en el primer nombre</span>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defunción'" id="input_beneficiarie_middle_name" type="text"
             v-model.trim="$v.beneficiarie_middle_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_middle_name.$error, 'inputsForm':!$v.beneficiarie_middle_name.$invalid}"
             placeholder="Segundo Nombre del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_middle_name')">
            <div class="content-text">
              <div v-if="$v.beneficiarie_middle_name.$error" class="text">
                <!--<span class="errors" v-if="!$v.beneficiarie_middle_name.required">El segundo nombre es requerido</span>-->
                <span class="errors" v-if="!$v.beneficiarie_middle_name.minLength">Debe ingresar más de 2 caracteres en el segundo nombre</span>
                <span class="errors" v-if="!$v.beneficiarie_middle_name.maxLength">Debe ingresar máximo 30 caracteres en el segundo nombre</span>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defunción'" id="input_beneficiarie_paternal_name" type="text"
             v-model="$v.beneficiarie_paternal_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_paternal_name.$error, 'inputsForm':!$v.beneficiarie_paternal_name.$invalid}"
              placeholder="Apellido Paterno del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_paternal_name')">
            <div class="content-text">
              <div v-if="$v.beneficiarie_paternal_name.$error" class="text">
                <span class="errors" v-if="!$v.beneficiarie_paternal_name.required">Debe seleccionar por lo menos un apellido</span>
                <span class="errors" v-if="!$v.beneficiarie_paternal_name.minLength">Debe ingresar más de 2 caracteres en el apellido paterno</span>
                <span class="errors" v-if="!$v.beneficiarie_paternal_name.maxLength">Debe ingresar máximo 30 caracteres en el apellido paterno</span>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defunción'" id="input_beneficiarie_maternal_name" type="text" 
              v-model="$v.beneficiarie_maternal_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_maternal_name.$error, 'inputsForm':!$v.beneficiarie_maternal_name.$invalid}"
              placeholder="Apellido Materno del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_maternal_name')">
            <div class="content-text">
              <div v-if="$v.beneficiarie_maternal_name.$error" class="text">
                <span class="errors" v-if="!$v.beneficiarie_maternal_name.required">Debe seleccionar por lo menos un apellido</span>
                <span class="errors" v-if="!$v.beneficiarie_maternal_name.minLength">Debe ingresar más de 2 caracteres en el apellido materno</span>
                <span class="errors" v-if="!$v.beneficiarie_maternal_name.maxLength">Debe ingresar máximo 30 caracteres en el apellido materno</span>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <div class="form-group">
              <input class="inputsForm" id="input_email" type="email" v-model.trim="$v.email.$model" 
                :class="{'inputs-invalid-form':$v.email.$error, 'inputsForm':!$v.email.$invalid}" placeholder="Correo Electrónico">
              <div class="content-text">
                <div v-if="$v.email.$error" class="text">
                  <span class="errors" v-if="!$v.email.required">El correo electrónico es requerido</span>
                  <span class="errors" v-if="!$v.email.isUnique">El formato del correo electrónico no es correcto. (su-correo@ejemplo.com)</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm" id="input_cellphone"  type="text" placeholder="Celular" 
              minlength="12" maxlength="12"  min="0" v-mask="'### ###-####'" v-model.trim="$v.cellphone.$model" 
              :class="{'inputs-invalid-form':$v.cellphone.$error, 'inputsForm':!$v.cellphone.$invalid}">
            <div class="content-text">
              <div v-if="$v.cellphone.$error" class="text">
                <span class="errors" v-if="!$v.cellphone.required">El celular es requerido</span>
                <span class="errors" v-if="!$v.cellphone.minLength">Debe ingresar los 10 dígitos del celular</span>
                <span class="errors" v-if="!$v.cellphone.maxLength">Debe ingresar los 10 dígitos del celular</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm" id="input_interbank_clabe" type="text" v-model.trim="$v.InterbankClabe.$model" placeholder="Clabe Interbancaria"
              :class="{'inputs-invalid-form':$v.InterbankClabe.$error, 'inputsForm':!$v.InterbankClabe.$invalid}" v-mask="'##################'">
            <div class="content-text">
              <div v-if="$v.InterbankClabe.$error" class="text">
                <span class="errors" v-if="!$v.InterbankClabe.required">La clabe interbancaria es requerida</span>
                <span class="errors" v-if="!$v.InterbankClabe.minLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
                <span class="errors" v-if="!$v.InterbankClabe.maxLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <select class="inputsForm" id="select_bank" v-model.trim="$v.bank.$model"
              :class="{'inputs-invalid-form':$v.bank.$error, 'inputsForm':!$v.bank.$invalid}">
              <option value="Banco" selected hidden>Banco</option>
              <option v-for="bank in list_banks" :key="bank.id" :value="bank.name">{{bank.name}}</option>
            </select>
            <div class="content-text">
              <div v-if="$v.bank.$error" class="text">
                <span class="errors" v-if="!$v.bank.isUnique">El banco es requerido</span>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:30px;">
          <div>
            <p class="titleComponent">Cargar Documentos</p>
          </div>
          <div class="contentLoadDocumentTable">
            <table class="table loadDocumentTable">
              <thead>
                <tr>
                  <th>Documento</th>
                  <th>Estatus</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Estado de Cuenta</td>
                  <td><Check v-show="loadCheckAccountStatus" /></td>
                  <td style="width:40%;">
                    <input v-show="!loadCheckAccountStatus" type="button" value="Cargar" id="button_load_document_account_status" class="loadDocumentButton" v-on:click="getFile('input_file_upload_account_status')">
                    <input v-show="loadCheckAccountStatus" type="button" value="Detalle de Documentos" id="button_detail_account_status" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('RAEC', 'Estado de Cuenta')" />
                    <div style='height: 0px;width:0px; overflow:hidden;'><input id="input_file_upload_account_status" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'RAEC', 'Estado de Cuenta')"/></div>
                  </td>
                </tr>
                <tr>
                  <td>Talones de Pago</td>
                  <td><Check v-show="loadCheckCheckBook" /></td>
                  <td style="width:40%;">
                    <input type="button" value="Cargar" id="button_load_document_checkBook" class="loadDocumentButton" v-on:click="getFile('input_file_upload_checkBook')">
                    <input v-show="loadCheckCheckBook" type="button" value="Detalle de Documentos" id="button_detail_checkBook" class="loadDocumentButtonWithoutBackground" 
                      style="margin-top:10px;" v-on:click="filterDocumentList('RATALON', 'Talones de Pagos')" />
                    <div style='height: 0px;width:0px; overflow:hidden;'><input id="input_file_upload_checkBook" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'RATALON', 'Talones de Pagos')"/></div>
                  </td>
                </tr>
                <tr>
                  <td>INE/IFE</td>
                  <td><Check v-show="loadIdentification" /></td>
                  <td style="width:40%;">
                    <input type="button" value="Cargar" id="button_load_document_identification" class="loadDocumentButton" v-on:click="getFile('input_file_upload_identification')">
                    <input v-show="loadIdentification" type="button" value="Detalle de Documentos" id="button_detail_identification" class="loadDocumentButtonWithoutBackground" 
                      v-on:click="filterDocumentList('RAIO', 'INE/IFE')" style="margin-top:10px;" />
                    <div style='height: 0px;width:0px; overflow:hidden;'><input id="input_file_upload_identification" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'RAIO', 'INE/IFE')"/></div>
                  </td>
                </tr>
                <tr v-if="reasonForTheRequest == 'defunción'">
                  <td>Acta de Defunción</td>
                  <td><Check v-show="loadDeathCertificate" /></td>
                  <td style="width:40%;">
                    <input v-show="!loadDeathCertificate" type="button" value="Cargar" id="button_load_document_death_certificate" class="loadDocumentButton" v-on:click="getFile('input_file_upload_death_certificate')">
                    <input v-show="loadDeathCertificate" type="button" value="Detalle de Documentos" id="button_detail_death_certificate" class="loadDocumentButtonWithoutBackground" v-on:click="filterDocumentList('RAAD', 'Acta de Defunción')" />
                    <div style='height: 0px;width:0px; overflow:hidden;'><input id="input_file_upload_death_certificate" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, 'RAAD', 'Acta de Defunción')"/></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="margin-top:30px">
          <div>
            <button class="AccessButton" id="button_save">Solicitar</button>
          </div>
          <div style="margin-top:10px">
            <div>
              <input type="button" value="Atrás" v-on:click="goBack()" class="AccessButtonWithoutBackground" id="backButton">
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import User from '@/classes/User'
import Saving from '@/classes/Saving'

import Document from '@/classes/Document'
import { getBanks } from "@/api/bank";

import Check from '@/components/Loading/Check.vue'
import Loading from '@/components/Loading/Loading.vue'
import Modal from '@/components/Modal/Modal.vue'
import Access from '@/components/Forms/Access.vue'
import PersonalInfo from '@/components/PersonalInfo/PersonalInfo.vue'

import {validateEmail} from '@/helpers/email'
import {required, minLength, maxLength, email, requiredIf} from 'vuelidate/lib/validators'

import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      isLoading: false,
      showModalListDocuments: false,
      rfcIsValid: false,
      modalTitle: "",
      reasonForTheRequest: "normal",
      token_auth: "",
      name: "",
      paternalName: "",
      maternalName: "",
      rfcToShow: "",
      activeColorBackground: '#198F99',
      inactiveColorBackground: '#FFF',
      activeColorText: '#FFF',
      inactiveColorText: '#198F99',
      activeBorderColor: "#198F99",
      inactiveBorderColor: "#198F99",
      userObjectClass: null,
      savingObjectClass: null,
      documentObjectClass: null,
      documents_list: [],
      documents_list_filtered: [],
      list_banks: [],
      bank: "Banco",
      email: "",
      InterbankClabe: "",
      cellphone: "",
      beneficiarie_name: "",
      beneficiarie_middle_name: "",
      beneficiarie_paternal_name: "",
      beneficiarie_maternal_name: "",
      loadCheckAccountStatus: false,
      loadCheckCheckBook: false,
      loadIdentification: false,
      loadDeathCertificate: false,
      accountStatus: "",
      checkBook: "",
      identification: "",
      deathCertificate: "",
      askNip: true,
      hasPendingRequest: false,
      showFormAccess: true,
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  validations: {
    beneficiarie_name: {
      required: requiredIf(function() {
        if (this.reasonForTheRequest == 'defunción')
          return true;
        return false;
      }),
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    beneficiarie_middle_name: {
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    beneficiarie_paternal_name: {
      required:requiredIf(function() {
        if (this.reasonForTheRequest == 'defunción' && this.beneficiarie_maternal_name == "")
          return true;
        return false;
      }),
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    beneficiarie_maternal_name: {
      required:requiredIf(function() {
        if (this.reasonForTheRequest == 'defunción' && this.beneficiarie_paternal_name == "")
          return true;
        return false;
      }),
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    email: {
      required,
      email,
      isUnique(value) {
        return validateEmail(value);
      }
    },
    cellphone: {
      required,
      minLength: minLength(12),
      maxLength: maxLength(12)
    },
    InterbankClabe: {
      required,
      minLength: minLength(18),
      maxLength: maxLength(18)
    },
    bank: {
      required,
      isUnique(value) {
        if (value == "Banco") {
          return false;
        }

        return true;
      }
    }
  },
  name: 'RenounceSavingComponent',
  components: {
    Loading,
    Modal,
    Access,
    PersonalInfo,
    Check
  },
  mounted() {
    this.userObjectClass = new User();
    this.savingObjectClass = new Saving();
    this.documentObjectClass = new Document();
    this.login();
  },
  methods: {
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;
        this.getBanks();
        console.log("token: ", this.token_auth);
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getBanks() {
      getBanks(this.token_auth).then(response => {
        this.list_banks = response.data.response.lista_bancos;
        console.log("banks: ", response);
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getResponseAccess(event) {
      console.log("event: ", event);
      if (event.rfcIsValid) {
        this.setAuthenticatedUserInformation(event.data)
        this.getPendingRequest();
      }
      this.rfcIsValid = event.rfcIsValid;
    },
    getPendingRequest() {
      this.savingObjectClass.getRenounce(this.token_auth, this.rfcToShow).then(response => {
        console.log("pending request: ", response);
        if (response.data.response.withdraw_saving_requests == undefined) {
          this.hasPendingRequest = false;
          this.showFormAccess = false;
        } else {
          this.hasPendingRequest = true;
          this.showFormAccess = true;
          Swal.fire({
            title: "Aviso",
            customClass: {
              container: 'my-swal'
            },
            text: "Ya cuenta con una solicitud creada para Renuncia del Ahorro.",
            icon: "info",
          });
        }
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    setAuthenticatedUserInformation(userAuthenticated) {
      this.name = userAuthenticated.name;
      this.paternalName = userAuthenticated.paternal_name;
      this.maternalName = userAuthenticated.maternal_name;
      this.rfcToShow = userAuthenticated.rfc;
    },
    renounce(e) {
      e.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoading = true;

        let documentsComplete = this.areDocumentsComplete();
        if (!documentsComplete) {
          this.isLoading = false;
          return;
        }

        if (this.reasonForTheRequest == "defunción") {
          if (this.areSurNamesEmpty()) {
          Swal.fire({
              title: "Aviso",
              customClass: {
                container: 'my-swal'
              },
              text: "Favor de llenar por lo menos un apellido del beneficiario",
              icon: "warning",
            });
            this.isLoading = false;
            return false;
          }
        }

        let json = this.buildJsonRenounce();

        if (this.reasonForTheRequest == "normal") {
          this.normalRenounce(json);
        } else {
          this.renounceByDeath(json);
        } 
      }
    },
    buildJsonRenounce() {
      let json = {};
      if (this.reasonForTheRequest == "normal") {
        json = {
          token_auth: this.token_auth,
          rfc: this.rfcToShow, 
          name: this.name,
          middle_name: "", 
          paternal_name: this.paternalName, 
          maternal_name: this.maternalName, 
          email: this.email, 
          cellphone: this.removeMask(this.cellphone), 
          account_number: this.InterbankClabe, 
          bank_name: this.bank, 
          withdraw_type: this.reasonForTheRequest
        };
      } else {
        json = {
          token_auth: this.token_auth,
          rfc: this.rfcToShow, 
          name: this.name,
          middle_name: "", 
          paternal_name: this.paternalName, 
          maternal_name: this.maternalName, 
          email: this.email, 
          cellphone: this.removeMask(this.cellphone), 
          account_number: this.InterbankClabe, 
          bank_name: this.bank, 
          withdraw_type: this.reasonForTheRequest,
          beneficiary_name: this.beneficiarie_name,
          beneficiary_middle_name: this.beneficiarie_middle_name,
          beneficiary_paternal_name: this.beneficiarie_paternal_name,
          beneficiary_maternal_name: this.beneficiarie_maternal_name
        };
      }

      return json;
    },
    normalRenounce(json) {
      this.savingObjectClass.normalRenounce(json).then(response => {
        this.uploadFiles(response.data.response.withdraw_saving_request.id).then(response => {
          this.isLoading = false;
          this.$refs.accessComponent.cleanFields();
          this.cleanValueChecks();
          this.cleanAllControls();
          console.log("response: ", response)
          Swal.fire({
            text: "Solicitud de prestamo guardada correctamente",
            html: `<p style="font-size:20px;font-weight:bold;">Se registró su solicitud de renuncia al ahorro exitosamente.</p> <br/>
                      <p style="font-size:16px;">Todas las solicitudes capturadas a través de esta página, 
                    serán analizadas y sujetas a aprobación por parte del Comité Técnico de la Sección 17.</p>`,
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
            icon: "success",
          }).then((response)=>{
          });
        }).catch(error => {
          this.isLoading = false;
          console.error(error);
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "error",
          });
        });
      }).catch(error => {
        this.isLoading = false;
        console.error(error);
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    renounceByDeath(json) {
      this.savingObjectClass.renounceByDeath(json).then(response => {
        this.uploadFiles(response.data.response.withdraw_saving_request.id).then(response => {
          this.isLoading = false;
          this.$refs.accessComponent.cleanFields();
          this.cleanValueChecks();
          this.cleanAllControls();
          console.log(response)
          Swal.fire({
            text: "Solicitud de prestamo guardada correctamente",
            html: `<p style="font-size:20px;font-weight:bold;">Se registró su solicitud de renuncia al ahorro exitosamente.</p> <br/>
                      <p style="font-size:16px;">Todas las solicitudes capturadas a través de esta página, 
                    serán analizadas y sujetas a aprobación por parte del Comité Técnico de la Sección 17.</p>`,
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
            icon: "success",
          }).then((response)=>{
          });
        }).catch(error => {
          this.isLoading = false;
          console.error(error);
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "error",
          });
        });        
      }).catch(error => {
        this.isLoading = false;
        console.error(error);
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    uploadFiles(requestId) {
      return this.documentObjectClass.uploadRenounceSavingDocuments(this.token_auth, requestId, this.documents_list).then(response => {
        return response;
      }).catch(error => {
        throw error;
      })
    },
    getFile(selector) {
      this.documentObjectClass.getFileByIdSelector(selector);
    },
    loadDocument(event, type, typeDescription) {
      let file = event.target.files;
      let filename = file[0].name;
      let extension = file[0].type.split('/')[1];

      if(this.documents_list.length > 0){
        if (!this.documentTypeReachItsLimit(type)) {
          if (this.existDocument(this.documents_list, filename.split('.')[0].replace(/\s/g, '_'))) {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: "El archivo seleccionado ya ha sido cargado",
              icon: "error",
            });
            return;
          } 
        } else {
          Swal.fire({
            title: "Aviso",
            text: `Solo puede subir 5 documentos en el apartado de ${typeDescription}`,
            icon: "error",
          });
          return;
        }
      }

      this.documentObjectClass.serialize(file[0]).then(base64Response => {
        this.setDocumentList(base64Response, filename.split('.')[0].replace(/\s/g, '_'), extension, type);
        this.changeValueChecks(true, type);
        this.showLoadedDocumentSuccessMessage(filename, typeDescription);
      }).catch(error => {
        console.error(error);
      });
    },
    setDocumentList(fileBase64, fileName, extension, abbreviation) {
      this.documents_list.push({
        file: fileBase64,
        name: fileName,
        extension: extension,
        abbreviation: abbreviation
      });
      console.log(this.documents_list);
    },
    changeButtonSelected(value, askNip) {
      this.reasonForTheRequest = value;
      this.askNip = askNip;
    },
    cleanValueChecks() {
      this.loadCheckAccountStatus = false;
      this.loadCheckCheckBook = false;
      this.loadIdentification = false;
      this.loadDeathCertificate = false;
    },
    changeValueChecks(value, document) {
      let index = -1;
      if (!value) {
        index = this.documents_list.findIndex(b => b.document_abbreviation === document);
        value = index != -1 ? true : value
      }

      switch (document) {
        case "RAEC":
          this.loadCheckAccountStatus = value;
          break;
        case "RATALON":
          this.loadCheckCheckBook = value;
          break;
        case "RAIO":
          this.loadIdentification = value;
          break;
        case "RAAD":
          this.loadDeathCertificate = value;
          break;
      }
    },
    showLoadedDocumentSuccessMessage(documentName, documentType) {
      Swal.fire({
        text: "Solicitud de prestamo guardada correctamente",
        html: `<p style="font-size:14px;font-family:Roboto;">El documento: <span style="font-weight:500;">${documentName}</span> se ha adjuntado en el apartado de ${documentType}.</p>`,
        confirmButtonText: "Continuar",
        allowOutsideClick: false,
        icon: "success",
      });
    },
    filterDocumentList(document, modalTitle) {
      this.documents_list_filtered = this.documents_list.filter(b => b.abbreviation === document);
      this.modalTitle = modalTitle;
      this.showModalListDocuments = true;
    },
    deleteDocument(document, documentName){
      Swal.fire({
        title: "Aviso",
        text: '¿Desea eliminar el documento?',
        icon: "warning",
        customClass: {
          container: 'my-swal'
        },
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then((result) => {
        if (result.value) {
          let indexDocuments = this.documents_list.findIndex(d => d.abbreviation === document && d.name === documentName);
          let indexDocumentsFiltered = this.documents_list_filtered.findIndex(d => d.abbreviation === document && d.name === documentName);
          if (indexDocuments != -1) {
            this.documents_list.splice(indexDocuments,1);
            this.changeValueChecks(false, document);
          } 
          if (indexDocumentsFiltered != -1) {
            this.documents_list_filtered.splice(indexDocumentsFiltered,1);
          } 
        }
      });
    },
    documentTypeReachItsLimit(document) {
      let documents = this.documents_list.filter(d => d.abbreviation === document);
      if (documents.length >= 5) {
        return true;
      }
      return false;
    },
    existDocument(documents, newDocument) {
      let indexDocuments = documents.findIndex(d => d.name === newDocument);
      if (indexDocuments != -1) {
        return true;
      }
      return false;
    },
    validateSpecialCharacters(field) {
      var regex = /^[a-zA-ZÀ-ÿ]+$/;
      if (regex.test(this[field]) != true) {
        this[field] = this[field].replace(/[^a-zA-ZÀ-ÿ@\s]+/, '');
      }
    },
    areDocumentsComplete() {
      let documentsComplete = true;

      if (this.reasonForTheRequest == "defunción") {
        if (!this.loadCheckAccountStatus || !this.loadCheckCheckBook || !this.loadIdentification || !this.loadDeathCertificate ) {
          documentsComplete = false;
        }
      } else {
        if (!this.loadCheckAccountStatus || !this.loadCheckCheckBook || !this.loadIdentification) {
          documentsComplete = false;
        }
      }

      if (!documentsComplete) {
        Swal.fire({
          title: "Aviso",
          text: "Favor de completar la carga de documentos.",
          icon: "warning",
        })
        return false;
      }

      return true;
    },
    areSurNamesEmpty() {
      if (this.beneficiarie_paternal_name == "" && this.beneficiarie_maternal_name == "") {
        return true;
      }

      return false;
    },
    removeMask(phone) {
      if (phone.includes("(")) {
        phone = phone.replace("(", "");
      }
      if (phone.includes(")")) {
        phone = phone.replace(")", "");
      }
      if (phone.includes("-")) {
        phone = phone.replace("-", "");
      }
      if (phone.includes(" ")) {
        phone = phone.replace(" ", "");
      }
      return phone;
    },
    cleanAllControls() {
      this.rfcToShow = "";
      this.rfcIsValid = false;
      this.showFormAccess = true;
      this.email = "";
      this.cellphone = "";
      this.InterbankClabe = "";
      this.bank = "Banco";
      this.documents_list = [];
      this.documents_list_filtered = [];
      this.beneficiarie_name = "";
      this.beneficiarie_middle_name = "";
      this.beneficiarie_paternal_name = "";
      this.beneficiarie_maternal_name = "";
      this.$v.$reset()
    },
    goBack() {
      this.cleanValueChecks();
      this.cleanAllControls();
      this.$refs.accessComponent.cleanFields();
    }
  }
}
</script>